<template>
  <div>
    <nav-bar ref="form"/>
    <div class="container py-16">
      <div class=" sec-garay-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            <page-title :titles="'تماس با ما'"/>
          </h5>
        </div>
      </div>
      <div v-if="isPageLoaded" class=" ">
        <div class="row">
          <div class="col-12 ">
            <v-img class="img-fluid mx-auto " :src="$replaceHttps(PageContent.fileUrl)" height="300"></v-img>
          </div>
        </div>

        <div class="container mx-auto row sec-garay-bg ">

          <div class="col-12 font-22" v-html="PageContent.description"></div>

          <v-card class="col-12 col-md-6 px-5">
            <div >
              <div class="font-weight-bold pb-5">آدرس دفتر مرکزی</div>
              <gmap-map
                  :center="centered"
                  ref="map"
                  :zoom="10"
                  style="width: 100%; height: 400px"
              >
                <gmap-marker
                    :key="index"
                    v-for="(m, index) in markerss"
                    :position="m"/>
              </gmap-map>
              <div class="row">
                <div class="col-6 col-md-3 mx-auto" v-for="item in cards" :key="item.id">
                  <a target="_blank" :href="item.cardPath">
                    <v-img :src="getImgUrl(item.src)" class="mx-auto bg-white img-fluid" alt="" ></v-img>
                  </a>
                </div>
              </div>
            </div>
          </v-card>

          <v-card class="col-12 col-md-6 px-5">
            <div >

              <div class="font-weight-bold pb-5">آدرس کارخانه</div>
              <gmap-map
                  :center="center"
                  ref="map"
                  :zoom="10"
                  style="width: 100%; height: 400px"
              >
                <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m"/>
              </gmap-map>
              <div class="row">
                <div class="col-6 col-md-3 mx-auto" v-for="item in card" :key="item.id">
                  <a target="_blank" :href="item.cardPath">
                    <v-img :src="getImgUrl(item.src)" class="mx-auto bg-white img-fluid" alt=""></v-img>
                  </a>
                </div>
              </div>
            </div>
          </v-card>


          <div class="col-12">
            <v-card class="mt-8 p-2 pt-0 pr-0 pl-0">
              <v-card-title class="justify-content-center primary-bg white--text p-0"><span
                  class="font-18"> شبکه های اجتماعی</span>
              </v-card-title>
              <div class="row">
                <div class="col-3 col-sm-2 col-md-1 text-center mx-auto"
                     v-for="item in socialNetworkItems" :key="item.id">
                  <a :href="item.link" target="_blank">
                    <v-img :src="$replaceHttps(item.imageUrl)" :alt=item.title></v-img>
                    <div class="mt-2">{{ item.title }}</div>
                    <!--                          <div class="mt-2">{{ item.description }}</div>-->
                  </a>
                </div>
              </div>
            </v-card>
          </div>
          <div class=" col-8 mx-auto contact-form-wrapper" v-if="isPageLoaded">
            <div class="border-radius">
              <div class="row ">
                <h5 class="text-blue col py-0 text-center">
                  فرم ارسال پیام
                </h5>
              </div>
            </div>
            <v-form ref="form">
              <div class="row">
                <div class="col-12">
                  <v-text-field solo flat v-model="name" placeholder="نام و نام خانوادگی"
                                :rules="required"
                  ></v-text-field>
                </div>
                <div class="col-12">
                  <v-text-field solo flat v-model="phoneNumber" type="number" placeholder="شماره موبایل"
                                :rules="phoneRules"></v-text-field>
                </div>
                <div class="col-12">
                  <v-textarea solo flat v-model="massage" placeholder="توضیحات" :rules="required"
                  ></v-textarea>
                </div>
                <div class="col-12">
                  <v-btn
                      block
                      color="secondary"
                      elevation="0"
                      @click="PostContactForm"
                  >
                    ارسال پیام
                  </v-btn>
                </div>
              </div>
            </v-form>
          </div>

          <div>
          </div>
        </div>
      </div>
      <!--      <div class="col-12 ">
              <div class="responsive-map ">
                <iframe  class="border border-radius-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2822.7806761080233!2d-93.29138368446431!3d44.96844997909819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x52b32b6ee2c87c91%3A0xc20dff2748d2bd92!2sWalker+Art+Center!5e0!3m2!1sen!2sus!4v1514524647889" width="100%" height="350px" frameborder="0" style="border:0" allowfullscreen></iframe>
              </div>
            </div>-->
      <v-dialog
          v-model="showResultDialog"
          hide-overlay
          persistent
          width="500">
        <v-card class="text-center">
          <v-card-title class="justify-space-between bg-Products ">
            <v-btn
                class="mr-2"
                icon
                @click="showResultDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-6">
            <div class="mb-0 black&#45;&#45;text py-5">{{ dialogResult }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>

import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";
import PageTitle from "@/components/titles";

export default {
  name: "contactUs",
  components: {PageTitle, FooterMenu, NavBar},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-تماس با ما'
  },
  data: () => ({
    logo: 'logo.png',
    center: {lat: 35.737613677978516, lng: 51.777713775634766},
    markers: [
      {
        lat: 35.737613677978516,
        lng: 51.777713775634766,
      },
    ],
    centered: {lat: 35.729201, lng: 51.575550},
    markerss: [
      {
        lat: 35.729201,
        lng: 51.575550,
      },
    ],

    card: [
      {id: 4, src: 'www.jpg', cardPath: 'https://waze.com/ul?ll=35.737613677978516,51.777713775634766&navigate=yes'},
      {id: 3, src: 'gg.jpg', cardPath: ' https://maps.google.com/?ll=35.737613677978516,51.777713775634766'},
      {id: 1, src: 'nnn.png', cardPath: 'https://neshan.org/maps/@35.737613677978516,51.777713775634766'},
      {id: 2, src: 'bb.jpg', cardPath: 'https://balad.ir/#=35.737613677978516,51.777713775634766'},
    ],
    cards: [
      {id: 4, src: 'www.jpg', cardPath: 'https://waze.com/ul?ll=35.729201,51.575550&navigate=yes'},
      {id: 3, src: 'gg.jpg', cardPath: ' https://maps.google.com/?ll=35.729201,51.575550'},
      {id: 1, src: 'nnn.png', cardPath: 'https://neshan.org/maps/@35.729201,51.575550'},
      {id: 2, src: 'bb.jpg', cardPath: 'https://balad.ir/#=35.729201,51.575550'},
    ],

    zoom: 10,
    isPageLoaded: false,
    PageContent: null,
    socialNetworkItems: [],
    name: null,
    phoneNumber: null,
    massage: null,
    phoneRules: [
      v => !!v || "پر کردن این فیلد الزامی است",
      v => (v && v.length === 11) || 'تلفن 11 رقم است.',
    ],
    required: [v => !!v || "پر کردن این فیلد الزامی است"],
    dialogResult: null,
    showLoaderDialog: false,
    showResultDialog: false,
  }),
  mounted() {
    this.getData()
    this.getSocialNetwork()
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },

    /*getCurrentLocation() {
      this.$getLocation({})
          .then(coordinates => {
            this.myCoordinates = coordinates;
            if (this.markers.length > 0) {
              this.markers.pop()
              this.markers.push(this.myCoordinates)
              this.$refs.mapRef.$mapPromise.then(map => map.panTo(coordinates));

            } else {
              this.markers.push(this.myCoordinates)
            }
          })
          .catch(error => console.log(error));
    },*/
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/PageContent?TypePage=4", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.PageContent = JSON.parse(result)
            this.isPageLoaded = true
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    },
    getSocialNetwork() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/SocialNetwork", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.socialNetworkItems = json
          })
          .catch(error => console.log('error', error));
    },
    PostContactForm() {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        this.showLoaderDialog = true

        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("MobileNumber", this.phoneNumber);
        urlencoded.append("Description", this.massage);
        urlencoded.append("NameAndFamily", this.name);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch("https://api.aslanianmachine.com/Home/PostContactForm", requestOptions)
            .then(response => response.text())
            .then(result => {
              this.showLoaderDialog = true
              this.dialogResult = result
              this.showResultDialog = true
            })
            .catch(error => console.log('error', error));
      }
    }
  }
}

</script>

<style scoped>

</style>


